import LoadingButton from '@mui/lab/LoadingButton'
import Button from '@mui/material/Button'
import { getActionProps } from './actionProps';

export default function PrimaryAction({loadingButton, children, sx = {}, ...rest}) {

    const props = {
        ...getActionProps('primaryAction', sx),
        ...rest
    }

    if(loadingButton) return (
        <LoadingButton {...props}>{children}</LoadingButton>
    )
    
    return (
        <Button {...props}>{children}</Button>
    )
}
